import React from "react";

function Pre({ load }) {
  return (
    <div id={load ? "preloader" : "preloader-none"}>
      <div className="preloader-terminal">
        <div className="preloader-terminal-header">
          <span className="preloader-dot dot-red"></span>
          <span className="preloader-dot dot-yellow"></span>
          <span className="preloader-dot dot-green"></span>
          <span className="preloader-terminal-title">boot.sh</span>
        </div>
        <div className="preloader-terminal-body">
          <p className="preloader-line">
            <span className="preloader-prompt">&gt;</span> whoami
          </p>
          <p className="preloader-line preloader-line-2">
            khushbu_r_hajari <span className="preloader-tag">[AI/ML + Full-Stack]</span>
          </p>
          <p className="preloader-line preloader-line-3">
            <span className="preloader-prompt">&gt;</span> booting_portfolio<span className="preloader-blink">_</span>
          </p>
          <div className="preloader-bar">
            <div className="preloader-bar-fill"></div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Pre;
